import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = `user`

    let options = { emulateJSON: false }

    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey : 'id',
      "ord": payload.event.ord,
      "role": payload.event.role,
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }

    http.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getClients ({commit}, payload) {
    let url = `clients`

    let options = { emulateJSON: false }

    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey : 'id',
      "ord": payload.event.ord,
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }

    http.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getOperators ({commit}, payload) {
    let url = `operators`

    let options = { emulateJSON: false }

    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey : 'id',
      "ord": payload.event.ord,
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }

    http.get(url, { params }, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getOperatorById({commit}, payload) {
    let url = `operator/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetById', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getAll ({commit}, payload) {
    let url = `user?page=1&perPage=-1`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetAll', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getById ({commit}, payload) {
    let url = `user/${payload.event.id}`
    let options = {
      emulateJSON: false
    }
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetById', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  post ({commit}, payload) {
    let url = 'user'

    let params = {
      'name': payload.event.item.name,
      'last_name': payload.event.item.last_name === '' ? undefined : payload.event.item.last_name,
      'email': payload.event.item.email,
      'password': payload.event.item.password,
      'phone': payload.event.item.phone === '' ? undefined : payload.event.item.phone,
      'role_id': payload.event.item.rolId,
      'company_id': payload.event.item.company_id,
      'sites': payload.event.item.site_ids ? payload.event.item.site_ids : undefined
    }
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  postClients ({commit}, payload) {
    let url = 'clients-list'
  
    let params = { 'clients': payload.event.items }

    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  postOperator ({commit}, payload) {
    let url = 'operators'

    let options = { 'Content-Type': 'multipart/form-data' }

    const params = new FormData()
    
    params.append('name', payload.event.item.name)
    params.append('last_name', payload.event.item.last_name)
    if(payload.event.item.license_number) params.append('licence_number', payload.event.item.license_number)
    if(payload.event.item.vigenteLicense) params.append('license_expiration', payload.event.item.vigenteLicense)
    if(payload.event.item.credential_number) params.append('credential_number', payload.event.item.credential_number)
    if(payload.event.item.photoCredential) params.append('credential', payload.event.item.photoCredential)
    if(payload.event.item.photoLicense) params.append('licence', payload.event.item.photoLicense)
    if(payload.event.item.photoUser) params.append("photo_file", payload.event.item.photoUser)

    http.post(url, params, options)
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  putOperator ({commit}, payload) {
    let url = `operators/${payload.event.item.id}?_method=PUT`

    let options = { 'Content-Type': 'multipart/form-data' }

    const params = new FormData()
    
    params.append('name', payload.event.item.name)
    params.append('last_name', payload.event.item.last_name)
    if(payload.event.item.license_number) params.append('licence_number', payload.event.item.license_number)
    if(payload.event.item.vigenteLicense) params.append('license_expiration', payload.event.item.vigenteLicense)
    if(payload.event.item.credential_number) params.append('credential_number', payload.event.item.credential_number)
    if(payload.event.item.photoCredential) params.append('credential', payload.event.item.photoCredential)
    if(payload.event.item.photoLicense) params.append('licence', payload.event.item.photoLicense)
    if(payload.event.item.photoUser) params.append("photo_file", payload.event.item.photoUser)

    http.post(url, params, options)
      .then(
        response => {
          commit('onPost', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  put ({commit}, payload) {
    let url = `user/${payload.event.item.id}`
    let params = {
      'name': payload.event.item.name,
      'last_name': payload.event.item.last_name,
      'email': payload.event.item.email,
      'password': payload.event.item.password !== '' ? payload.event.item.password : undefined,
      'phone': payload.event.item.phone,
      'role_id': payload.event.item.rolId,
      'company_id': payload.event.item.company_id,
      'sites': payload.event.item.site_ids ? payload.event.item.site_ids : undefined
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  putClient ({commit}, payload) {
    let url = `clients/${payload.event.item.id}`
    let params = {
      'name': payload.event.item.name,
      'contact': payload.event.item.contact,
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  updateOwn ({commit}, payload) {
    let url = 'user-own'
    http.put(url, payload.event.user, {})
      .then(
        response => {
          commit('onUpdateOwn', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  delete ({commit}, payload) {
    let url = `user/${payload.event.id}`

    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  deleteOperator ({commit}, payload) {
    let url = `operators/${payload.event.id}`

    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  deleteClients ({commit}, payload) {
    let url = `clients/${payload.event.id}`

    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  getInspect ({commit}, payload) {
    let url = `user-role`
    let options = {
      emulateJSON: false
    }
    let params = {
      "role_id": payload.event.role_id = 3,
      "find": payload.event.find !== '' ? payload.event.find : undefined
    }
    http.get(url, { params }, options)
      .then(
        response => {
          commit('onGetInspect', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  postOperatorAndInspector ({commit}, payload) {
    let url = 'operator-user'

    let params = {
      'id_operator': payload.event.item.id_operator,
      'email': payload.event.item.email,
      'password': payload.event.item.password
    }

    http.post(url, params, {})
      .then(
        response => {
          commit('onPostOperatorAndInspector', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  }
}

export default actions